module.exports = __webpack_public_path__ + "static/img/pp_advert1.d61b6dc5.gif";